import { useTranslation } from 'react-i18next'
import * as SelectPrimitive from '@radix-ui/react-select'
import { Globe } from 'lucide-react'
import {
  Select,
  SelectContent,
  SelectItem,
} from '@/components/ui/select'
import { useTimezone } from '@/hooks/useTimezone'
import { getCommonTimezones } from '@/lib/dateTime'

export function TimezoneSelector() {
  const { t } = useTranslation()
  const { timezone, setTimezone } = useTimezone()
  const timezones = getCommonTimezones()

  // Use Radix Trigger directly so the icon centers cleanly — matches LanguageSwitcher.
  return (
    <Select value={timezone} onValueChange={setTimezone}>
      <SelectPrimitive.Trigger
        aria-label={t('timezone.displayTimezone')}
        title={t('timezone.displayTimezone')}
        className="inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-pill border border-ink/15 bg-transparent text-ink outline-none transition hover:border-ink/35 hover:bg-ink/5 hover:text-gold focus-visible:ring-2 focus-visible:ring-gold-soft"
      >
        <Globe className="h-4 w-4" strokeWidth={1.6} />
      </SelectPrimitive.Trigger>
      <SelectContent>
        <SelectItem value="browser">{t('timezone.browserDefault')}</SelectItem>
        {timezones.map((tz) => (
          <SelectItem key={tz.value} value={tz.value}>
            {tz.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  )
}
